import React, { Component, Fragment } from 'react';
import RatingsForm from './RatingsForm';

class DepartmentSettingsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        riskAlert: this.props.settings.riskAlert,
        scale: this.props.settings.scale,
      },
    };
  }

  render() {
    return (
      <Fragment>
        <div className="app-content">
          <RatingsForm
            isLoading={this.props.isLoading}
            initialValues={this.state.initialValues}
            onSave={formData => this.props.onSave(formData)}
          />
        </div>
      </Fragment>
    );
  }
}

export default DepartmentSettingsEdit;
